import { AnimatePresence } from 'framer-motion';
import { TUploadErrorCode } from 'preflight-core';
import { useEffect, useState } from 'react';

import { UploadState } from '../utils/use-upload-document';
import { NudgingDocx } from './nudge-docx-new';
import { SlideNew } from './slider-new';

type OnFileSelected = (file: File) => void;

export const NudgingSlider = ({
  uploadState,
  onFileSelected,
  open,
  setOpen,
  onContinueWithPdfClick,
  uploadStateContinuePdf,
}: {
  uploadState: UploadState;
  onFileSelected: OnFileSelected;
  open: boolean;
  onContinueWithPdfClick: (param: boolean) => void;
  setOpen: (openDialog: boolean) => void;
  uploadStateContinuePdf?: {
    name: string;
    error?: { json: { errorCode: TUploadErrorCode; errorReason: string } };
    data?: { json: object };
  };
}) => {
  const [isSettingsOpen, setIsSettingsOpen] = useState(true);

  const handleContinueWithPdfCallback = (boolValue: boolean) => {
    onContinueWithPdfClick(boolValue);
    setIsSettingsOpen;
  };

  function openSettings() {
    setIsSettingsOpen(true);
    document.body.style.overflowY = 'hidden';
  }

  function closeSettings() {
    setIsSettingsOpen(false);
    document.body.style.overflowY = 'scroll';
    setOpen(false);
  }

  useEffect(() => {
    if (open) {
      openSettings();
    } else {
      closeSettings();
    }
  }, [open]);

  return (
    <>
      <AnimatePresence>
        <SlideNew open={isSettingsOpen}>
          <NudgingDocx
            uploadState={uploadState}
            onFileSelected={onFileSelected}
            onContinueWithPdfClick={handleContinueWithPdfCallback}
            uploadStateContinuePdf={uploadStateContinuePdf}
          />
        </SlideNew>
      </AnimatePresence>
    </>
  );
};
